import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  track() {
    window.dataLayer ||= []
    window.dataLayer.push({
      event: this.element.dataset.analyticsEvent,
      support_placement: this.element.dataset.analyticsPlacement
    })
  }

  supportCheckout() {
    window.dataLayer ||= []
    window.dataLayer.push({
      event: this.element.dataset.analyticsEvent,
      payment_provider: "stripe"
    })
  }

  directions() {
    window.dataLayer ||= []
    window.dataLayer.push({
      event: this.element.dataset.analyticsEvent,
      place_id: this.element.dataset.analyticsPlaceId,
      directions_provider: "google_maps"
    })
  }
}
